import React from 'react';
import { StyleSheet, View } from 'react-native';

import { AnimatedViews, Icon, ListAction, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const CreditMenuItemLoading = () => {
  return (
    <ListAction.Wrapper>
      <AnimatedViews.Pulse style={styles.container}>
        <View style={styles.icon} />

        <View style={styles.content}>
          <View style={styles.title} />

          <View style={styles.amount} />
        </View>

        <Icon name="IconCaretRight" color={theme.colors.NEUTRAL_2} width={18} height={18} />
      </AnimatedViews.Pulse>
    </ListAction.Wrapper>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexGrow: 1,
    alignItems: 'center',
    paddingVertical: theme.spacing['2'],
  },
  icon: {
    width: 24,
    height: 24,
    marginRight: theme.spacing['4'],
    borderRadius: theme.radius.small,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
  },
  content: {
    flex: 1,
  },
  title: {
    width: 96,
    height: 10,
    marginVertical: 4,
    borderRadius: theme.radius.small,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
  },
  amount: {
    width: 40,
    height: 10,
    marginVertical: 4,
    borderRadius: theme.radius.small,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
  },
});
